import React from "react";
import "./CTA.css"

const CTA = ({ className, style, text, setHeroCTARef, tracker, ...props }) => {
  return (
    <a
      className={`cta relative font-bold bg-accent px-10 text-primary text-sm leading-normal font-medium rounded-sm focus:outline-none ${className}`}
      href="https://dashboard.steinhq.com/"
      style={{
        paddingTop: "0.875rem",
        paddingBottom: "0.875rem",
        ...style
      }}
      {...props}
      onClick={() => {
        tracker();
      }}
    >
      {text}
    </a>
  );
};

export default React.memo(CTA);
